export default "__VITE_ASSET__EML3Q64s__"